"use strict";
exports.__esModule = true;
var fp_ts_1 = require("fp-ts");
function singleNode(a) {
    var l = { a: a, prev: null, next: null };
    l.prev = l;
    l.next = l;
    return l;
}
/**
 * Push an Elem at the end of the List
 */
function push(list, a) {
    if (isNotEmpty(list)) {
        var last_1 = list.last;
        var first = list.first;
        var newLast = { a: a, next: first, prev: last_1 };
        last_1.next = newLast;
        first.prev = newLast;
        list.last = newLast;
    }
    else {
        var l = singleNode(a);
        list.first = l;
        list.last = l;
    }
}
exports.push = push;
/**
 * Creates an empty List
 */
function empty() {
    return { first: null, last: null };
}
exports.empty = empty;
/**
 * Indicates if a List is a singleton
 */
function isSingleton(list) {
    return list.first === list.last && isNotEmpty(list);
}
/**
 * Indicates if a List is not empty
 */
function isNotEmpty(list) {
    return list.first !== null;
}
exports.isNotEmpty = isNotEmpty;
/**
 * Pops the first element of a List (A | null)
 */
function popUnsafe(list) {
    var first = list.first;
    if (first) {
        if (isSingleton(list)) {
            list.first = null;
            list.last = null;
        }
        else {
            first.next.prev = first.prev;
            first.prev.next = first.next;
            list.first = first.next;
        }
        return first.a;
    }
    else {
        return null;
    }
}
exports.popUnsafe = popUnsafe;
/**
 * Pops the first element of a List (A | null)
 */
function popLastUnsafe(list) {
    var last = list.last;
    if (last) {
        if (isSingleton(list)) {
            list.first = null;
            list.last = null;
        }
        else {
            last.prev.next = last.next;
            last.next.prev = last.prev;
            list.last = last.prev;
        }
        return last.a;
    }
    else {
        return null;
    }
}
exports.popLastUnsafe = popLastUnsafe;
/**
 * Pops the first element of a List Option<A>
 */
function pop(list) {
    return fp_ts_1.option.fromNullable(popUnsafe(list));
}
exports.pop = pop;
/**
 * Gets the first element of the List as Option<A> (does not change the List)
 */
function headUnsafe(list) {
    return list.first !== null ? list.first.a : null;
}
exports.headUnsafe = headUnsafe;
/**
 * Gets the first element of the List as Option<A> (does not change the List)
 */
function head(list) {
    return fp_ts_1.option.fromNullable(headUnsafe(list));
}
exports.head = head;
/**
 * Gets the last element of the List as A | null (does not change the List)
 */
function lastUnsafe(list) {
    return list.last !== null ? list.last.a : null;
}
exports.lastUnsafe = lastUnsafe;
/**
 * Gets the last element of the List as Option<A> (does not change the List)
 */
function last(list) {
    return fp_ts_1.option.fromNullable(lastUnsafe(list));
}
exports.last = last;
